import { takeLatest, select, call, put } from 'redux-saga/effects'

import * as ACTIONTYPES from '../constants/actiontypes'
import {
  getBookFramesTime,
} from '../selectors/selectors'


function* doAfterCurrentTimeChanged() {
  const framesTime = yield select(getBookFramesTime);
  // console.log('framesTime', framesTime);
}



export default function* watchCurrentTimeChange() {
  yield takeLatest(
    [
      ACTIONTYPES.CURRENT_TIME_CHANGE,
    ],
    doAfterCurrentTimeChanged
  )
}


// WEBPACK FOOTER //
// ./src/store/sagas/playing.js